import { useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";

export function useBalancesByCurrencyRange(startDate: string, endDate: string) {
  const [balances, setBalances] = useState<Record<string, any[]>>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBalances = async () => {
      setLoading(true);
      const { data, error } = await supabase.rpc(
        "get_balances_by_account_range",
        {
          start_date: startDate,
          end_date: endDate,
        }
      );

      if (error) {
        console.error(error);
        setLoading(false);
        return;
      }

      const grouped = data.reduce((acc, account) => {
        if (!acc[account.currency]) acc[account.currency] = [];
        acc[account.currency].push(account);
        return acc;
      }, {} as Record<string, any[]>);

      setBalances(grouped);
      setLoading(false);
    };

    fetchBalances();
  }, [startDate, endDate]);

  return { balances, loading };
}
